import React, { useState } from 'react';

function StepFour({ formData, onNext }) {
    const [kinName, setKinName] = useState(formData.kinName || '');
    const [kinLName, setKinLName] = useState(formData.kinLName || '');
    const [kinAddress, setKinAddress] = useState(formData.kinAddress || '');
    const [kinMobile, setKinMobile] = useState(formData.kinMobile || '');
    const [kinEmail, setKinEmail] = useState(formData.kinEmail || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!kinName || !kinAddress || !kinMobile || !kinEmail) {
            setError('Please fill out all required fields.');
            return;
        }

        setError('');
        onNext({
            kinName,
            kinLName,
            kinAddress,
            kinMobile,
            kinEmail,
        });
    };

    const isFormValid = kinName && kinAddress && kinMobile && kinEmail;

    return (
        <div className="step-form">
            <h6 className="mb-4">Emergency Contact Details</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <div className="row">
                <div className="col-lg-6">
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            value={kinName}
                            placeholder="First Name"
                            onChange={e => setKinName(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            value={kinLName}
                            placeholder="Last Name"
                            onChange={e => setKinLName(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="mb-3">
                        <input
                            type="tel"
                            className="form-control"
                            placeholder="Phone Number"
                            value={kinMobile}
                            onChange={e => setKinMobile(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="mb-3">
                        <input
                            type="email"
                            className="form-control"
                            placeholder="Email"
                            value={kinEmail}
                            onChange={e => setKinEmail(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Address"
                            value={kinAddress}
                            onChange={e => setKinAddress(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!isFormValid}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default StepFour;
